import { render, staticRenderFns } from "./DamageAssessorCaseCreate.vue?vue&type=template&id=2696c404&scoped=true"
import script from "./DamageAssessorCaseCreate.vue?vue&type=script&lang=js"
export * from "./DamageAssessorCaseCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2696c404",
  null
  
)

export default component.exports